export enum TypeActionInvivation {
  resend = "resend",
  edit = "edit",
}
